import { render, staticRenderFns } from "./coucherlist.vue?vue&type=template&id=1c880511&scoped=true"
import script from "./coucherlist.vue?vue&type=script&lang=js"
export * from "./coucherlist.vue?vue&type=script&lang=js"
import style0 from "./coucherlist.vue?vue&type=style&index=0&id=1c880511&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c880511",
  null
  
)

export default component.exports